import { render } from "./BreakBoard.vue?vue&type=template&id=0b8e1b82&scoped=true"
import script from "./BreakBoard.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./BreakBoard.vue?vue&type=script&charset=utf-8&lang=js"

import "./BreakBoard.vue?vue&type=style&index=0&id=0b8e1b82&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8e1b82"]])

export default __exports__